import React, { useState, useEffect } from 'react';
import AdminLogin  from './AdminLogin';
import AdminLayout from './AdminLayout';
import API from '../../services/api';

export default function AdminRoot() {
  const [admin,   setAdmin]   = useState(null);
  const [token,   setToken]   = useState(null);
  const [checked, setChecked] = useState(false);

  /* Restore session on mount */
  useEffect(() => {
    const validateSession = async () => {
      try {
        const savedToken = localStorage.getItem('adminToken');
        const savedAdmin = localStorage.getItem('adminUser');
        const isDemo = localStorage.getItem('adminMode') === 'demo';

        if (savedToken && savedAdmin) {
          const parsed = JSON.parse(savedAdmin);
          
          if (!isDemo) {
            // Verify token with backend
            try {
              const r = await API.get('/admin/me', {
                headers: { Authorization: `Bearer ${savedToken}` }
              });
              // The backend returns { success: true, admin: req.admin }
              setAdmin(r.data.admin);
              setToken(savedToken);
            } catch (err) {
              // Token expired or invalid
              handleLogout();
            }
          } else {
            setAdmin(parsed);
            setToken(savedToken);
          }
        }
      } catch {
        handleLogout();
      } finally {
        setChecked(true);
      }
    };
    
    validateSession();
  }, []);

  const handleLogin = (adminData, tok) => {
    setAdmin(adminData);
    setToken(tok);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    localStorage.removeItem('adminMode');
    setAdmin(null);
    setToken(null);
  };

  /* Prevent flash of login page on refresh */
  if (!checked) {
    return (
      <div style={{
        minHeight:'100vh', background:'#0d0d0d',
        display:'flex', alignItems:'center', justifyContent:'center'
      }}>
        <div style={{
          width:32, height:32,
          border:'3px solid rgba(201,168,76,.3)',
          borderTopColor:'#c9a84c',
          borderRadius:'50%',
          animation:'spin .8s linear infinite'
        }}/>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }

  if (!admin || !token) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return <AdminLayout admin={admin} onLogout={handleLogout} />;
}
